import IAuthUser from "../interfaces/IAuthUser";

class AuthUser {
    token: string
    userID: string | undefined | null
    userName: string | undefined | null
    email: string | undefined | null
    name: string | undefined | null
    googleCreated: string | undefined | null
    role: string | undefined | null
    termsAccepted: string | undefined | null
    businessID: string | undefined | null
    totalRestaurants: string | undefined | null
    defaultMenuID: string | undefined | null
    hasPassword: string | undefined | null
    usedFreeTrial: string | undefined | null

    sub: any | null

    constructor(validation?: Partial<IAuthUser>) {
        if (validation) {
            Object.assign(this, validation);
        }
    }
}

export default AuthUser;